import { render, staticRenderFns } from "./CustomersImportPage.vue?vue&type=template&id=24a32622&scoped=true"
import script from "./CustomersImportPage.vue?vue&type=script&lang=js"
export * from "./CustomersImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a32622",
  null
  
)

export default component.exports